export default __webpack_public_path__ + "/images/BlankTwo.1d00575ebe03b6100973143f24c19590.png";